import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    ViewEncapsulation,
    signal,
    computed,
    OnInit,
} from "@angular/core";
import { UserprefService } from "../../services/userpref.service";

@Component({
    selector: "task-time",
    template: `
        @if (init()) {
            <div class="time-wrapper">
                <div>
                    {{ displayDate() | timeFormat: timeFormat() }}
                </div>

                @if (isEndDate() && spansMidnight()) {
                    <div class="end-date">({{ eventEnd() | dateFormat: dateFormat() }})</div>
                }
            </div>
        }
    `,
    styles: [
        `
            .time-wrapper {
                min-width: 149px;
            }

            .end-date {
                font-size: 10px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TaskTimeComponent implements OnInit {
    eventStart = signal<Date | null>(null);
    eventEnd = signal<Date | null>(null);
    isEndDate = signal(false);

    // Internal signals
    init = signal(false);
    dateFormat = signal<string>("");
    timeFormat = signal<string>("");

    // Inputs that update the signals
    @Input()
    set eventStartInput(value: Date | null) {
        this.eventStart.set(value);
    }

    @Input()
    set eventEndInput(value: Date | null) {
        this.eventEnd.set(value);
    }

    @Input()
    set isEndDateInput(value: boolean) {
        this.isEndDate.set(value);
    }

    displayDate = computed(() => (this.isEndDate() ? this.eventEnd() : this.eventStart()));

    spansMidnight = computed(
        () =>
            this.isEndDate() &&
            this.eventEnd() &&
            this.eventStart() &&
            this.eventEnd()!.toDateString() !== this.eventStart()!.toDateString(),
    );

    constructor(private cd: ChangeDetectorRef) {}

    async ngOnInit() {
        const [dateFormat, timeFormat] = await Promise.all([
            UserprefService.getS25Dateformat(),
            UserprefService.getS25Timeformat(),
        ]);

        this.dateFormat.set(dateFormat);
        this.timeFormat.set(timeFormat);
        this.init.set(true);
    }
}
